/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersAuthRefreshMutationResponse, PostUsersAuthRefresh400 } from "../entities/PostUsersAuthRefresh";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postUsersAuthRefresh } from "../api/postUsersAuthRefresh";
import { useMutation } from "@tanstack/react-query";

export const postUsersAuthRefreshMutationKey = () => [{ url: '/users/auth/refresh' }] as const

export type PostUsersAuthRefreshMutationKey = ReturnType<typeof postUsersAuthRefreshMutationKey>

/**
 * @description User refresh
 * @summary Refresh
 * {@link /users/auth/refresh}
 */
export function usePostUsersAuthRefresh<TContext>(options: 
{
  mutation?: UseMutationOptions<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postUsersAuthRefreshMutationKey()

  return useMutation<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, void, TContext>({
    mutationFn: async() => {
      return postUsersAuthRefresh(config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}